export const valueMapping = {
    yearsInOperation: [
        {
            code: '06',
            en: 'Less than 6 Months',
            bm: 'Kurang dari 6 bulan',
        },
        {
            code: '61',
            en: '6 months to less than 1 year',
            bm: '6 bulan hingga kurang dari 1 tahun',
        },
        {
            code: '23',
            en: '2 years to less than 3 years',
            bm: '2 tahun hingga kurang dari 3 tahun',
        },
        {
            code: '24',
            en: '3 years to less than 4 years',
            bm: '3 tahun hingga kurang dari 4 tahun',
        },
        {
            code: '40',
            en: '4 years and above',
            bm: '4 tahun dan ke atas',
        },
    ],
    sectors: [
        {
            code: '001',
            en: 'Energy',
            bm: 'Tenaga',
        },
        {
            code: '002',
            en: 'Education',
            bm: 'Pendidikan',
        },
        {
            code: '003',
            en: 'Food and Beverage',
            bm: 'Makanan dan Minuman',
        },
        {
            code: '004',
            en: 'Agriculture and Forestry',
            bm: 'Pertanian dan Perhutanan',
        },
        {
            code: '005',
            en: 'Environment and Biodiversity',
            bm: 'Persekitaran dan Biokepelbagaian',
        },
        {
            code: '006',
            en: 'Smart Cities and Transportation',
            bm: 'Bandar Pintar dan Pengangkutan',
        },
        {
            code: '007',
            en: 'Medical and Healthcare',
            bm: 'Perubatan dan Penjagaan Kesihatan',
        },
        {
            code: '008',
            en: 'Culture, Arts and Tourism',
            bm: 'Budaya, Seni dan Pelancongan',
        },
        {
            code: '009',
            en: 'Business and Financial Services',
            bm: 'Perkhidmatan Perniagaan dan Kewangan',
        },
        {
            code: '010',
            en: 'Technologies and Intelligent',
            bm: 'Teknologi dan Intelektual',
        },
        {
            code: '011',
            en: 'Hospitality',
            bm: 'Hospitaliti',
        },
        {
            code: '012',
            en: 'Oil & Gas Services',
            bm: 'Perkhidmatan Minyak dan Gas',
        },
        {
            code: '013',
            en: 'Global Establishment',
            bm: 'Penubuhan Global',
        },
        {
            code: '014',
            en: 'Research & Development',
            bm: 'Penyelidikan dan Pembangunan',
        },
        {
            code: '015',
            en: 'Other services',
            bm: 'Lain-lain Perkhidmatan',
        },
    ],
    fundValues: [
        {
            code: '52',
            en: '50,000 - 200,000',
            bm: '50,000 - 200,000',
        },
        {
            code: '23',
            en: '200,001 - 300,000',
            bm: '200,001 - 300,000',
        },
        {
            code: '35',
            en: '300,001 - 500,000',
            bm: '300,001 - 500,000',
        },
        {
            code: '56',
            en: '500,001 - 500,000',
            bm: '500,001 - 500,000',
        },
        {
            code: '67',
            en: '600,001 and above',
            bm: '600,001 dan ke atas',
        },
    ],
};
